import React from 'react';

import { useSvgId } from '../icons/icon-utils';

export function DecorativeLogo() {
  const gradientId = useSvgId('decorative-logo-gradient');

  return (
    <svg
      fill="none"
      height="100%"
      preserveAspectRatio="xMidYMax meet"
      style={{
        bottom: 0,
        height: '100%',
        left: 0,
        position: 'absolute',
        width: '100%',
      }}
      viewBox="0 0 401 412"
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.35">
        <path
          clipRule="evenodd"
          d="M243.172 4.10106C221.225 -6.13318 195.136 3.36216 184.902 25.3095L129.31 144.527C119.076 166.475 128.571 192.563 150.519 202.797C172.466 213.032 198.554 203.536 208.789 181.589L264.381 62.371C274.615 40.4236 265.12 14.3353 243.172 4.10106ZM132.012 242.564C110.065 232.33 83.9763 241.825 73.7421 263.772L18.1499 382.99C7.91564 404.938 17.411 431.026 39.3584 441.26C61.3058 451.495 87.3942 441.999 97.6284 420.052L153.221 300.834C163.455 278.887 153.959 252.798 132.012 242.564ZM264.117 188.282C274.351 166.335 300.44 156.839 322.387 167.074C344.334 177.308 353.83 203.396 343.596 225.344L252.798 420.06C242.564 442.007 216.476 451.502 194.528 441.268C172.581 431.034 163.085 404.945 173.32 382.998L264.117 188.282ZM377.195 445.753C407.466 445.753 432.005 421.214 432.005 390.944C432.005 360.674 407.466 336.135 377.195 336.135C346.925 336.135 322.386 360.674 322.386 390.944C322.386 421.214 346.925 445.753 377.195 445.753Z"
          fill={`url(#${gradientId})`}
          fillRule="evenodd"
        />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={gradientId}
          x1="99.9937"
          x2="-133.455"
          y1="-112.517"
          y2="321.153"
        >
          <stop stopColor="#CB3E6D" />
          <stop offset="1" stopColor="#146EE8" />
        </linearGradient>
      </defs>
    </svg>
  );
}
